import './index.less';
import React, { useEffect, useState } from 'react';
// 引入子组件
import UsersList from './usersList';

// 顶部导航Tabs组件
import { Tabs } from 'antd';

const ComponySet = () => {
  // 顶部导航Tabs相关
  const { TabPane } = Tabs;
  const onChange = (key: string) => {
    console.log(key);
  };

  return (
    <div>
      <div>
        <div className="web_head">用户管理</div>
        <div className="content_box">
          <div className="gapBox"></div>
          <UsersList />
        </div>
      </div>
    </div>
  );
};

export default ComponySet;
